import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-farms-section',
  standalone: true,
  templateUrl: './farms-section.component.html'
})
export class FarmsSectionComponent {
  public state = inject(AppStateService);
}
